import { defaulted, enums, object, string } from 'superstruct';
export const SortDirection = enums(['asc', 'desc']);
/**
 * @deprecated This does not limit what fields can be sorted by. Use {@link SortQuery} instead.
 */
export const UnsafeSortQuery = object({
  sort: string(),
  sortDirection: SortDirection
});

/**
 * @deprecated This does not limit what fields can be sorted by. Use {@link SortQuery} instead.
 */
export function UnsafeSortQueryDefaulted(defaultSort, defaultSortDirection) {
  return object({
    sort: defaulted(UnsafeSortQuery.schema.sort, defaultSort),
    sortDirection: defaulted(UnsafeSortQuery.schema.sortDirection, defaultSortDirection)
  });
}
export function SortQuery(sortableFieldNames) {
  return object({
    sort: enums(sortableFieldNames),
    sortDirection: SortDirection
  });
}
export function SortQueryDefaulted(sortableFieldNames, defaultSort, defaultSortDirection) {
  const s = SortQuery(sortableFieldNames);
  return object({
    sort: defaulted(s.schema.sort, defaultSort),
    sortDirection: defaulted(s.schema.sortDirection, defaultSortDirection)
  });
}